import ServiceCategoryPage from "../components/ServiceCategoryPage";
import fabricatorService from "../data/services/fabricatorService";

function Fabricator() {
  return <ServiceCategoryPage service={fabricatorService} />;
}

export default Fabricator;